import { handleActions, createAction } from 'redux-actions';

export const CREATE_CHANNEL_ACTIVATION = createAction('CREATE/CHANNEL_ACTIVATION');
export const CREATE_CHANNEL_ACTIVATION_SUCCESS = createAction('CREATE/CHANNEL_ACTIVATION/SUCCESS');
export const CREATE_CHANNEL_ACTIVATION_ERROR = createAction('CREATE/CHANNEL_ACTIVATION/ERROR');
export const FETCH_CHANNEL_ACTIVATION = createAction('FETCH_CHANNEL_ACTIVATION');
export const FETCH_CHANNEL_ACTIVATION_SUCCESS = createAction('FETCH_CHANNEL_ACTIVATION_SUCCESS');
export const FETCH_CHANNEL_ACTIVATION_FAIL = createAction('FETCH_CHANNEL_ACTIVATION_FAIL');


const initialState = {};

const channelsActivationReducer = handleActions(
  {
    [CREATE_CHANNEL_ACTIVATION_ERROR]: (state, payload) => {
      return { ...state, createChannelActivationErrors: payload, };
    },
    [FETCH_CHANNEL_ACTIVATION_SUCCESS]: (state, { payload, }) => {
      return { ...state, channel_activation_data: payload, };
    },
  },
  initialState
);

export default channelsActivationReducer;
